import { render } from "./Parametre.vue?vue&type=template&id=5812ca3e&scoped=true&class=bg-white%20h-full"
import script from "./Parametre.vue?vue&type=script&lang=js"
export * from "./Parametre.vue?vue&type=script&lang=js"

import "./Parametre.vue?vue&type=style&index=0&id=5812ca3e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5812ca3e"]])

export default __exports__